module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<a\n    href="#fp_view_start"\n    aria-controls="floorplans"\n    role="tab"\n    class="app-back-button"\n>\n    <span class="icon-font icon-arrow-left"></span>Back\n</a>\n\n<ul class="list-unstyled unit-listing">\n    <li class="header">\n        <span class="ui-select"></span>\n        ';
 if (!hideUnitNumbers) { 
__p+='\n        <span class="ui-1"\n              data-sort="number">\n            '+
((__t=( apartmentType ))==null?'':__t)+
'\n            ';
 if (sort.key === "number") { 
__p+='\n            <span class="'+
((__t=( sortClass ))==null?'':__t)+
'"></span>\n            ';
 } 
__p+='\n        </span>\n        ';
 } 
__p+='\n        <span class="ui-2"\n              data-sort="rent">\n            Rent\n            ';
 if (sort.key === "rent") { 
__p+='\n            <span class="'+
((__t=( sortClass ))==null?'':__t)+
'"></span>\n            ';
 } 
__p+='\n        </span>\n        <span class="ui-3"\n              data-sort="available_date">\n            Available\n            ';
 if (sort.key === "available_date") { 
__p+='\n            <span class="'+
((__t=( sortClass ))==null?'':__t)+
'"></span>\n            ';
 } 
__p+='\n        </span>\n    </li>\n    ';
 units.forEach(function(unit) { 
__p+='\n    ';

        var unitClassList = ["lined-box", "unit-details"];
        if (unit.promo()) {
            unitClassList.push("has-unit-promo");
        }
    
__p+='\n    <li>\n        <a\n            href="#fp_view_detailed"\n            aria-controls="floorplans"\n            role="tab"\n            id="unit'+
((__t=( unit.get('id') ))==null?'':__t)+
'"\n            class="'+
((__t=( unitClassList.join(" ") ))==null?'':__t)+
'"\n        >\n            <div class="ui-select">\n                <div class="radio">\n                    <label>\n                        <input\n                            type="radio"\n                            name="optionsRadios"\n                            value="unit'+
((__t=( unit.get('id') ))==null?'':__t)+
'"\n                            '+
((__t=( active && active.get("id") === unit.get("id") ? "checked" : "" ))==null?'':__t)+
'\n                        >\n                    </label>\n                </div>\n            </div>\n            ';
 if (!hideUnitNumbers) { 
__p+='\n            <span class="ui-1">#'+
((__t=( unit.get("number") ))==null?'':__t)+
'</span>\n            ';
 } 
__p+='\n            ';
 if(unit.get("promo")) { 
__p+='\n                <span class="ui-2">\n                    <s>'+
((__t=( unit.get("rent") ))==null?'':__t)+
' </s>\n                    '+
((__t=( unit.get("promo") ))==null?'':__t)+
'\n                </span>\n            ';
 } else { 
__p+='\n                <span class="ui-2">'+
((__t=( unit.get("rent") ))==null?'':__t)+
'</span>\n            ';
 } 
__p+='\n            <span class="ui-3">'+
((__t=( unit.get("available_label") ))==null?'':__t)+
'</span>\n            ';
 if (unit.promo()) { 
__p+='\n                <img class="promo-tag unit-listing-promo-tag" src="/static/images/svg/promo-tag.svg" alt="promo tag icon" />\n            ';
 } 
__p+='\n        </a>\n    </li>\n    ';
 }) 
__p+='\n</ul>\n';
 if (useListDisclaimer) { 
__p+='\n<div class="unit-list-description">\n    <p>'+
((__t=( listDisclaimer ))==null?'':_.escape(__t))+
'\n</div>\n';
 } 
__p+='\n';
 if (noUnits) { 
__p+='\n<p class="li-no-units">\n    <a href="'+
((__t=( contactLinkURL ))==null?'':_.escape(__t))+
'">'+
((__t=( noAvailableUnitsText ))==null?'':_.escape(__t))+
'</a>\n    ';
 if (availabilityLink) { 
__p+='\n    <span class="unit-list-availability-link">\n        '+
((__t=( availabilityFirstText ))==null?'':_.escape(__t))+
'<a href="'+
((__t=( availabilityLink ))==null?'':__t)+
'" target="_blank">'+
((__t=( availabilityLinkText ))==null?'':_.escape(__t))+
'</a>'+
((__t=( availabilitySecondText ))==null?'':_.escape(__t))+
'\n    </span>\n    ';
 } 
__p+='\n    ';
 if (useKnockContact) { 
__p+='\n    <span class="unit-list-knock-contact">\n        '+
((__t=( knockContactFirstText ))==null?'':_.escape(__t))+
'<a href="#" onclick="event.preventDefault(); knockDoorway.openContact();">'+
((__t=( knockContactLinkText ))==null?'':_.escape(__t))+
'</a>'+
((__t=( knockContactSecondText ))==null?'':_.escape(__t))+
'\n    </span>\n    ';
 } 
__p+='\n</p>\n';
 } 
__p+='\n';
}
return __p;
};
